import { createFileRoute } from "@tanstack/react-router";
import { AuthPage } from "../components/auth/auth-page";
import { leaveIfSignedIn } from "../lib/session-gate";

export const Route = createFileRoute("/sign-in")({
  beforeLoad: leaveIfSignedIn,
  component: () => <AuthPage mode="sign-in" />,
});
